import { FC } from 'react';
import { useIntl } from 'react-intl';

import { FatalError } from '../FatalError/FatalError';

export const MissingProductDescriptionErrorForm: FC<{ onReload: () => void }> = ({ onReload }) => {
  const { formatMessage } = useIntl();
  return (
    <FatalError titleKey="productDescriptionFailure.title" detailsKey="productDescriptionFailure.details">
      <button type="button" onClick={onReload} className="btn btn-primary mt-3">
        {formatMessage({ id: 'productDescriptionFailure.button' })}
      </button>
    </FatalError>
  );
};
MissingProductDescriptionErrorForm.displayName = 'MissingProductDescriptionErrorForm';

export const MissingProductReferentialErrorForm: FC<{ onReload: () => void }> = ({ onReload }) => {
  const { formatMessage } = useIntl();
  return (
    <FatalError titleKey="productReferentialFailure.title" detailsKey="productReferentialFailure.details">
      <button type="button" onClick={onReload} className="btn btn-primary mt-3">
        {formatMessage({ id: 'productReferentialFailure.button' })}
      </button>
    </FatalError>
  );
};
MissingProductReferentialErrorForm.displayName = 'MissingProductReferentialErrorForm';
